var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"information-card"},[(_vm.title)?_c('div',{staticClass:"title"},[_c('p',{staticClass:"font-sm"},[_vm._v(_vm._s(_vm.title))])]):_vm._e(),_vm._t("content")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }